import {AnswerTemplateDto} from "../../answer-templates/feature/answer-templates/domain/dtos";
import {companyMock1, companyMock2, companyMock3} from "./company.mock";
import {AnswerTemplateAggregate} from "@livechat/answer-templates";

export const answerTemplateMock1: AnswerTemplateDto = {
  idAnswerTemplate: 1,
  title: 'answer-template-1',
  content: 'Answer template 1',
  companiesIds: [companyMock1.companyId],
  companyNames: `${companyMock1.companyName}`,
  selected: false,
};

export const answerTemplateAggregateMock1: AnswerTemplateAggregate = AnswerTemplateAggregate.getInstance({
  idAnswerTemplate: 1,
  title: 'answer-template-1',
  content: 'Answer template 1',
  companiesIds: ['company-1'],
});

export const answerTemplateMock2: AnswerTemplateDto = {
  idAnswerTemplate: 2,
  title: 'answer-template-2',
  content: 'Answer template 2',
  companiesIds: [companyMock2.companyId],
  companyNames: `${companyMock2.companyName}`,
  selected: false,
};

export const answerTemplateMock3: AnswerTemplateDto = {
  idAnswerTemplate: 3,
  title: 'answer-template-3',
  content: 'Answer template 3',
  companiesIds: [companyMock3.companyId],
  companyNames: `${companyMock3.companyName}`,
  selected: false,
};

export const answerTemplateMockWithHtmlColors: AnswerTemplateDto = {
  idAnswerTemplate: 1,
  title: 'answer-template-1',
  content: '<p style="color: red;">Answer <b style="background-color: #FFFFFF;">template</b> with <a style="background: transparent;" href="somewhere.com" target="_blank">html</a></p>',
  companiesIds: [companyMock1.companyId],
  companyNames: `${companyMock1.companyName}`,
  selected: false,
};

export const answerTemplateMockWithHtml: AnswerTemplateDto = {
  idAnswerTemplate: 1,
  title: 'answer-template-with-html',
  content: '<p>Answer <b>template</b> with <a href="somewhere.com" target="_blank">html</a></p>',
  companiesIds: [companyMock1.companyId, companyMock2.companyId, companyMock3.companyId],
  companyNames: `${companyMock1.companyName}, ${companyMock2.companyName}, ${companyMock3.companyName}`,
  selected: false,
};

export const answerTemplateMockList: Array<AnswerTemplateDto> = [answerTemplateMock1, answerTemplateMock2, answerTemplateMock3];

export const answerTemplateMockWithHtmlColorsExpectedContent = '<p >Answer <b >template</b> with <a  href="somewhere.com" target="_blank">html</a></p>';
